var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncreasingUsage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.75 0C1.16421 0 1.5 0.335786 1.5 0.75V22.5H23.25C23.6642 22.5 24 22.8358 24 23.25C24 23.6642 23.6642 24 23.25 24H0.75C0.335786 24 0 23.6642 0 23.25V0.75C0 0.335786 0.335786 0 0.75 0ZM18.75 12C19.1642 12 19.5 12.3358 19.5 12.75V18.75C19.5 19.1642 19.1642 19.5 18.75 19.5C18.3358 19.5 18 19.1642 18 18.75V12.75C18 12.3358 18.3358 12 18.75 12ZM15 15.75C15 15.3358 14.6642 15 14.25 15C13.8358 15 13.5 15.3358 13.5 15.75V16.5V18.75C13.5 19.1642 13.8358 19.5 14.25 19.5C14.6642 19.5 15 19.1642 15 18.75V15.75ZM24 9.75C24 9.33579 23.6642 9 23.25 9C22.8358 9 22.5 9.33579 22.5 9.75V18.75C22.5 19.1642 22.8358 19.5 23.25 19.5C23.6642 19.5 24 19.1642 24 18.75V9.75ZM4.71967 18.2197C4.42678 18.5126 4.42678 18.9874 4.71967 19.2803C5.01256 19.5732 5.48744 19.5732 5.78033 19.2803L22.5 2.56066L22.5 5.25C22.5 5.66421 22.8358 6 23.25 6C23.6642 6 24 5.66421 24 5.25L24 0.749999C24 0.335786 23.6642 0 23.25 0H18.75C18.3358 0 18 0.335786 18 0.749999C18 1.16421 18.3358 1.5 18.75 1.5L21.4393 1.5L4.71967 18.2197Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncreasingUsage);
export default __webpack_public_path__ + "static/media/increasing-usage.cebf7ae14f18945b16dd0d3a7cf4df34.svg";
export { ForwardRef as ReactComponent };